import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export class Searchbar extends React.Component {
  static propTypes = {
    values: PropTypes.array.isRequired,
    searchField: PropTypes.string,
    labelField: PropTypes.string,
    placeholder: PropTypes.string,
  }

  static defaultProps = {
    values: [],
    searchField: 'title',
    labelField: 'title',
    placeholder: 'search',
  }

  constructor(props) {
    super(props)

    this.handleFilterValue = _.debounce(this.handleFilterValue, 500)
  }

  state = {
    isDropdown: false,
    isLoading: false,
    filterText: '',
    filterValues: this.props.values,
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.values, prevProps.values)) {
      this.setState({
        filterValues: this.props.values,
      })
    }
  }

  handleDropdown = () => {
    this.setState({
      isDropdown: !_.isEmpty(this.state.filterValues),
      isLoading: false,
    })
  }

  handleTextFocus = () => {
    this.setState({
      isDropdown: true,
    })
  }

  handleFilterValue = () => {
    const filterValues = _.filter(this.props.values, value => {
      const currentValue = _.chain(value)
        .get(this.props.searchField)
        .replace(' ', '')
        .toLower()
        .value()
      const filterText = _.toLower(this.state.filterText)
      return _.includes(currentValue, filterText)
    })

    this.setState(
      {
        filterValues: _.take(filterValues, 20),
      },
      this.handleDropdown,
    )
  }

  handleTextChange = ({ target: { value } }) => {
    this.setState(
      { filterText: value, isLoading: true },
      this.handleFilterValue,
    )
  }

  handleMouseLeaveDropdown = () => {
    this.setState({ isDropdown: false })
  }

  handleItemClick = value => {
    this.setState({ isDropdown: false })
    if (this.props.onItemClick) {
      this.props.onItemClick(value)
    }
  }

  render() {
    return (
      <div>
        <div
          className={classNames('dropdown', {
            'is-active': this.state.isDropdown,
          })}
          style={{ display: 'block' }}
        >
          <div className="dropdown-trigger">
            <div
              className={classNames('control', {
                'is-loading': this.state.isLoading,
              })}
            >
              <input
                className="input is-rounded"
                type="text"
                placeholder={this.props.placeholder}
                onFocus={this.handleTextFocus}
                onChange={this.handleTextChange}
              />
            </div>
          </div>
          <div
            className="dropdown-menu"
            role="menu"
            onMouseLeave={this.handleMouseLeaveDropdown}
          >
            <div className="dropdown-content">
              {_.map(this.state.filterValues, (value, index) => (
                <a
                  key={index}
                  className="dropdown-item"
                  onClick={() => this.handleItemClick(value)}
                >
                  {_.get(value, this.props.labelField)}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/views/widgets/Searchbar.js